export const ZHI_TUI_BAO = 'zhiTuiBao'
export const ZHI_GUANG_TONG = 'zhiGuangTong'

export const API_TYPE = {
  [ZHI_TUI_BAO]: 'zhiTuiBaoAnalysisData',
  [ZHI_GUANG_TONG]: 'zhiGuangTongAnalysisData'
}

export const ANALYSIS_LIST = {
  [ZHI_TUI_BAO]: [
    {
      label: '曝光展示',
      unit: '次',
      key: ZHI_TUI_BAO + '@daily_display_count',
      help: '广告展现在婚礼纪客户端后，实际被用户看到的次数，实时更新。'
    },
    {
      label: '点击量',
      unit: '次',
      key: ZHI_TUI_BAO + '@daily_click_count',
      help: '广告展现在婚礼纪客户端后，实际被用户看到并且点击的次数，实时更新。'
    },
    {
      label: '点击率',
      unit: '',
      valueUnit: '%',
      key: ZHI_TUI_BAO + '@daily_click_percent',
      help: '点击率=点击量/曝光展示×100%，实时更新。'
    },
    {
      label: '感兴趣',
      unit: '次',
      key: ZHI_TUI_BAO + '@daily_interest_count',
      help: '通过推广获得的收藏、关注等用户行为，次日更新。'
    },
    {
      label: '转化',
      unit: '次',
      key: ZHI_TUI_BAO + '@daily_convert_count',
      help:
        '通过推广获得的交易转化次数之和，具体包括：预约、优惠券领取、电话、在线咨询。次日更新。'
    }
  ],
  [ZHI_GUANG_TONG]: [
    {
      label: '总花费',
      unit: '元',
      key: ZHI_GUANG_TONG + '@daily_total_fee',
      help: '广告实际的费用消耗（包括奖励金），实时更新。'
    },
    {
      label: '曝光展示',
      unit: '次',
      key: ZHI_GUANG_TONG + '@daily_display_count',
      help: '广告展现在婚礼纪客户端后，实际被用户看到的次数，实时更新。'
    },
    {
      label: '点击量',
      unit: '次',
      key: ZHI_GUANG_TONG + '@daily_click_count',
      help: '广告展现在婚礼纪客户端后，实际被用户看到并且点击的次数，实时更新。'
    },
    {
      label: '点击率',
      unit: '',
      valueUnit: '%',
      key: ZHI_GUANG_TONG + '@daily_click_percent',
      help: '点击率=点击量/曝光展示×100%，实时更新。'
    },
    {
      label: '千次曝光均价',
      unit: '元',
      key: ZHI_GUANG_TONG + '@average_price',
      help: '千次曝光均价=总花费/曝光展示×1000。'
    },
    {
      label: '感兴趣',
      unit: '次',
      key: ZHI_GUANG_TONG + '@daily_interest_count',
      help: '通过推广获得的收藏、关注等用户行为，次日更新。'
    },
    {
      label: '转化',
      unit: '次',
      key: ZHI_GUANG_TONG + '@daily_convert_count',
      help:
        '通过推广获得的交易转化次数之和，具体包括：预约、优惠券领取、电话、在线咨询。次日更新。'
    }
  ]
}

export const RADIO_GROUP = [
  {
    label: '今日',
    value: '0'
  },
  {
    label: '昨日',
    value: '1'
  },
  {
    label: '近7日',
    value: '7'
  },
  {
    label: '近15日',
    value: '15'
  },
  {
    label: '近30日',
    value: '30'
  }
]
